/**
 * ORDEM ALFABÉTICA — a "configuração" única de ordenação por nome do sistema.
 *
 * Mesmo critério da agenda do Planejamento (AgendaView): A→Z em português,
 * sem diferenciar maiúscula/minúscula nem acento ("Álvaro" fica junto de
 * "Adolfo", não depois do "Z"), e com números em ordem natural ("Equipe 2"
 * antes de "Equipe 10").
 *
 * A ordem é garantida NA TELA: não dependemos de a API devolver ordenado (o
 * ORDER BY do banco depende da collation e o cadastro pode vir de outro
 * sistema). Use `ordenarPorNome` no ponto de exibição de toda lista de pessoas
 * ou de cadastros identificados por nome.
 *
 * NÃO use em listas cuja ordem natural é data/número (NCs, auditorias, planos
 * de ação por prazo, histórico) nem em rankings (maior total primeiro).
 */

const OPCOES: Intl.CollatorOptions = { sensitivity: "base", numeric: true };

/** Compara dois nomes em ordem alfabética crescente (pt-BR). Vazio/nulo vira "". */
export const compararNomes = (a: unknown, b: unknown): number =>
  String(a ?? "").localeCompare(String(b ?? ""), "pt-BR", OPCOES);

/**
 * Devolve uma CÓPIA da lista em ordem alfabética pelo nome escolhido — a lista
 * original nunca é alterada (arrays usados por índice continuam intactos).
 * A ordenação é estável: empates mantêm a ordem em que chegaram.
 */
export function ordenarPorNome<T>(lista: readonly T[], nome: (item: T) => unknown): T[] {
  return [...lista].sort((a, b) => compararNomes(nome(a), nome(b)));
}
